import React, { Component, Fragment } from 'react';
import './budget-table.scss';
import { withNamespaces } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import BigCategories from 'modules/budget/components/budget-table/big-categories';

const Loading = ({colspan}) => (
    <tr>
        <td colSpan={colspan}>
            <div className="progress">
                <div className="progress-bar-indeterminate" />
            </div>
        </td>
    </tr>);

@withNamespaces()
@inject('store')
@observer
class BudgetTable extends Component {
    render() {
        const COLSPAN = 5;
        const { t, store } = this.props;
        const { loading, categories } = store.budget;
        const { isMobile } = store.app;
        const cellStyle = {width: isMobile ? '25%' : '15%'};

        return (
            <Fragment>
                <table className="table table-bordered table-hover table-condensed table-budget">
                    <thead>
                    <tr className="row-details-header">
                        <th colSpan={isMobile ? 3 : 1}>{t('BUDGET.TABLE.NAME')}</th>
                        <th className="hidden-sm hidden-xs" style={cellStyle}>{t('BUDGET.TABLE.BUDGET')}</th>
                        <th className="hidden-sm hidden-xs" style={cellStyle}>{t('BUDGET.TABLE.ACTUAL')}</th>
                        <th colSpan={isMobile ? 2 : 1} style={cellStyle}>{t('BUDGET.TABLE.REMAINING')}</th>
                        <th style={{width: 100}}>{t('BUDGET.TABLE.ACTIONS')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? <Loading colspan={COLSPAN} /> : <BigCategories categories={categories} />}
                    </tbody>
                </table>
            </Fragment>
        );
    }
}

export default BudgetTable;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/budget-table.js